<template>
	<div v-if="loading">
		<div class="loader"></div>
	</div>
	<div v-else-if="Object.keys(team).length > 0" class="headed-table headed-table--sticky-labels w-100">
		<table  class="w-100">
			<thead>
				<tr>
					<th>
						<small v-if="is_job" >Staff on Job</small>
                    	<small v-else >Staff in Company</small>
					</th>
					<th v-for="(header, index) in ppe_types" :key="index">
						<small>{{ header }}</small>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr class="head-table--row"  v-for="(user, rowIndex) in team" :key="rowIndex">
					<td>
						<a :href="generateRouteUser(user.id)" class="people-list--item-title" target="_blank">
							<h5 class="people-list--item-title-name">{{user.full_name}}</h5>
							<h6 class="people-list--item-title-email">{{user.email}}</h6>
                        </a>
					</td>
					<td v-for="(cell, ppeIndex) in ppe_types" :key="ppeIndex">
						<div class="d-flex justify-content-center">
							<template v-for="(ppe) in user.ppe.ppe_items">
                                <a v-if="ppe.ppe_register_item_id == ppeIndex" :href="generateRouteSubmission(ppe.job_id, ppe.form_submission_id)" target="_blank" :key="ppe.ppe_register_item_id">
                                    <div class="badge badge--sm badge--primary">
                                        <small> {{ppe.count}} </small>
                                    </div>
                                </a>
							</template>
							<template v-if="user.ppe.other_ppe">
                                <a  v-if="user.ppe.other_ppe.ppe_register_item_name == cell" :href="generateRouteSubmission(ppe.job_id, ppe.form_submission_id)" target="_blank">
                                    <div class="badge badge--sm badge--primary">
                                        <small> {{ user.ppe.other_ppe.count }} </small>
                                    </div>
                                </a>
							</template>
						</div>
					</td>
				</tr>
			</tbody>
		</table>

	</div>
	<div v-else class="headed-table no-results d-flex justify-content-center">
		<div class="text-center">
			<h5 class="m-4 mx-auto text-dark">No staff assigned to job</h5>
		</div>
    </div>
</template>

<script>
    import generateRoute, { generateRouteWithMultipleParameters } from "../../helpers/routes";
	export default {
		name: "PpeComponent",
		props: {
			loading:true,
			team:{},
			ppe_types:{},
            is_job: null,
            show_user_url: '',
            show_submission_url: '',
		},
        methods: {
            generateRouteSubmission(job, submission) {
                return generateRouteWithMultipleParameters(this._props.show_submission_url, {'job?': job, 'submission?': submission});
            },
            generateRouteUser(userId) {
                return generateRoute(this._props.show_user_url, userId);
            },
        }
	}
</script>

<style lang="scss" scoped>
.no-results {
	overflow-x: auto !important;
	overflow-y: auto !important;
}

</style>
